import PropTypes from 'prop-types';

import { getPromptPillValue } from '@helpers';
import { CloseBoldIcon, OverlayTriggerTooltip, truncateTextWithEllipsis } from '@utilities';
import styles from './_index.module.scss';

const SelectedAnswers = ({ activePrompt, setSelectedAnswers, transformedAnswersMap }) => {
  const promptKeys = activePrompt?.groupedPrompts?.length
    ? activePrompt.groupedPrompts.map((prompt) => prompt.promptKey)
    : [activePrompt?.promptKey];
  const currentAnswers = promptKeys.flatMap(
    (promptKey) => transformedAnswersMap?.[promptKey] || []
  );

  if (!currentAnswers || currentAnswers.length === 0) {
    return null;
  }

  const flattenedValues = currentAnswers.flatMap((group) => group.values);

  const handleRemoveAnswer = ({ answerId }) => {
    setSelectedAnswers((prev) =>
      promptKeys.reduce(
        (acc, promptKey) => ({
          ...acc,
          [promptKey]: (acc[promptKey] || []).filter(({ id }) => id !== answerId),
        }),
        { ...prev }
      )
    );
  };

  return (
    <ul className={styles['selected-answers']}>
      {flattenedValues?.map((answer, index) => {
        const answerPrompt = activePrompt?.groupedPrompts
          ? activePrompt.groupedPrompts.find((groupedPrompt) =>
              transformedAnswersMap?.[groupedPrompt.promptKey]?.some((group) =>
                group.values.some((value) => value.id === answer.id)
              )
            )
          : activePrompt;
        const value = getPromptPillValue({
          answers: { [answerPrompt?.id]: [answer] },
          prompt: answerPrompt,
        });
        const truncatedValue = truncateTextWithEllipsis({
          length: 19,
          text: value,
        });

        return (
          <li key={`selected-answers-${index}`}>
            <OverlayTriggerTooltip content={value} isFullWidth>
              <div className={styles['selected-answer-container']}>
                <p className={styles['selected-answer']}>{truncatedValue}</p>
                <CloseBoldIcon onClick={() => handleRemoveAnswer({ answerId: answer.id })} />
              </div>
            </OverlayTriggerTooltip>
          </li>
        );
      })}
    </ul>
  );
};

SelectedAnswers.propTypes = {
  activePrompt: PropTypes.object.isRequired,
  setSelectedAnswers: PropTypes.func.isRequired,
  transformedAnswersMap: PropTypes.object.isRequired,
};

export default SelectedAnswers;
